import { Store } from "vuex";
import { MEETING_TYPE } from "@/resources/constants/meeting";
import { CONFIG, ConfigInterface } from "@/resources/constants/system";
import { CHAT_TYPE } from "@/resources/constants/chat";
export default class Reactions {
  addReaction(store: Store<any>, data) {
    const reaction = {
      emoji: data.emoji,
      spaceUser: data.fromSpaceUser,
      room: data.room,
      timeOut: setTimeout(
        () => {
          store?.dispatch("SystemStore/removeReactionAction", {
            emoji: data.emoji,
            spaceUser: data.fromSpaceUser,
            room: data.room,
          });
        },
        data.emoji === "U+1F44F" ? 5000 : 1000
      ),
    };
    store?.dispatch("SystemStore/addReactionsAction", reaction);

    const roomId = store.getters["MeetingStore/getRoomId"];
    const chatType = store.getters["ChatStore/getChatType"];
    if (
      data.room &&
      roomId &&
      data.room === roomId &&
      chatType === CHAT_TYPE.ROOM
    ) {
      const user = store?.getters["SpaceStore/getUsersInSpace"].filter(
        (a) => a.id === data.fromSpaceUser
      )[0];
      /* const chatReaction = {
        Content: data.emoji,
        Metadata: `{"type":"REACTION","roomId":"${data.room}"}`,
        Sender: {
          Name:
            user.user.name +
            " " +
            (user.user.lastName ? user.user.lastName : ""),
        },
        CreatedTimestamp: new Date().toString(),
      };

      store?.dispatch("ChatStore/addNewMessageAction", chatReaction); */
    }

    const meetingType = store.getters["MeetingStore/getMeetingType"];
    if (meetingType !== MEETING_TYPE.SPEED_NETWORKING) {
      this.applauseReaction(store);
      this.clownReaction(store);
      this.drumReaction(store);
      this.womanReaction(store);
    }
  }
  applauseReaction(store: Store<any>) {
    const reactions = store.getters["SystemStore/getReactions"];
    const roomId = store.getters["MeetingStore/getRoomId"];
    if (roomId && roomId !== 0) {
      const applauseInRoom = reactions.filter(
        (a) => a.room === roomId && a.emoji === "U+1F44F"
      );
      if (applauseInRoom.length >= 4) {
        const config: ConfigInterface = store.getters["UserStore/getConfig"];
        if (!config.sound.silenceReactions) {
          const audio = new Audio(require("@/assets/audio/applause.mp3"));
          audio.volume = 0.2;
          audio.play().then();
        }
      }
    }
  }
  clownReaction(store: Store<any>) {
    const reactions = store.getters["SystemStore/getReactions"];
    const roomId = store.getters["MeetingStore/getRoomId"];
    if (roomId && roomId !== 0) {
      const applauseInRoom = reactions.filter(
        (a) => a.room === roomId && a.emoji === "U+1F921"
      );
      if (applauseInRoom.length >= 1) {
        const config: ConfigInterface = store.getters["UserStore/getConfig"];
        if (!config.sound.silenceReactions) {
          const audio = new Audio(require("@/assets/audio/clown.mp3"));
          audio.volume = 0.2;
          audio.play().then();
        }
      }
    }
  }
  drumReaction(store: Store<any>) {
    const reactions = store.getters["SystemStore/getReactions"];
    const roomId = store.getters["MeetingStore/getRoomId"];
    if (roomId && roomId !== 0) {
      const applauseInRoom = reactions.filter(
        (a) => a.room === roomId && a.emoji === "U+1F941"
      );
      if (applauseInRoom.length >= 1) {
        const config: ConfigInterface = store.getters["UserStore/getConfig"];
        if (!config.sound.silenceReactions) {
          const audio = new Audio(require("@/assets/audio/joke.mp3"));
          audio.volume = 0.2;
          audio.play().then();
        }
      }
    }
  }
  womanReaction(store: Store<any>) {
    const reactions = store.getters["SystemStore/getReactions"];
    const roomId = store.getters["MeetingStore/getRoomId"];
    if (roomId && roomId !== 0) {
      const applauseInRoom = reactions.filter(
        (a) => a.room === roomId && a.emoji === "U+1F631"
      );
      if (applauseInRoom.length >= 1) {
        const config: ConfigInterface = store.getters["UserStore/getConfig"];
        if (!config.sound.silenceReactions) {
          const audio = new Audio(require("@/assets/audio/woman.mp3"));
          audio.volume = 0.2;
          audio.play().then();
        }
      }
    }
  }
}
